var config_settings = {
    "production": {
        application_env: 'production',
        server_path: 'https://api.designmaker.designs.ai/api/',
        static_file_server_path: 'https://doim4mi2arjdd.cloudfront.net/api/',
        auth_redirect_path_mm: '/mockupmaker/start/',
        auth_redirect_path_dm: '/designmaker/start/',
        designs_ai_server_path: 'https://designs.ai/',
        designs_ai_auth_server_path: 'https://api.designmaker.designs.ai/',
        website_url: 'https://designs.ai/',
        public_cookie_domain: '.designs.ai',
        dm_client_id: 'tru2ibrichucun4yari4ofrebratlch3',
        mm_client_id: 'phlspigathl8i4a9ayofrethic0trowl',
        gtm_id: 'GTM-TQS2XSP',
        font_base_url: '/usr/src/app/'
    },
    "staging": {
        application_env: 'staging',
        server_path: 'https://dev-api.designmaker.designs.ai/api/' ,
        static_file_server_path: 'https://dev-api.designmaker.designs.ai/api/',
        auth_redirect_path_mm: '/mockupmaker/start/',
        auth_redirect_path_dm: '/designmaker/start/',
        designs_ai_server_path: 'https://dev.designs.ai/',
        designs_ai_auth_server_path: 'https://dev-api.designs.ai/',
        website_url: 'https://dev.designs.ai/',
        public_cookie_domain: '.designs.ai',
        dm_client_id: 'dridlwrl1rumocibrum56lclzad3usw6',
        mm_client_id: '7rlthowugedowrerimarugu8ridravaw',
        gtm_id: 'GTM-PF78C33',
        font_base_url: '/usr/src/app/'
    },
    "dev": {
        application_env: 'dev',
        server_path: 'https://dev-api.designmaker.designs.ai/api/' ,
        static_file_server_path: 'https://dev-api.designmaker.designs.ai/api/',
        auth_redirect_path_mm: '/mockupmaker/start/',
        auth_redirect_path_dm: '/designmaker/start/',
        designs_ai_server_path: 'https://dev.designs.ai/',
        designs_ai_auth_server_path: 'https://dev-api.designs.ai/',
        public_cookie_domain: '.designs-ai.loc',
        website_url: 'http://localhost:3000/',
        dm_client_id: 'dridlwrl1rumocibrum56lclzad3usw6',
        mm_client_id: '7rlthowugedowrerimarugu8ridravaw',
        gtm_id: 'GTM-PF78C33',
        // font_base_url: '/usr/src/app/'
        font_base_url: '/home/koushik/inmagine/backend/'
        // font_base_url: '/Users/penguin04/work/vetiver/inmagine-mockup-backend/'
    }
};


var config = config_settings[process.env.REACT_APP_ENV];
global.config = config;
